import React from "react";
import './home.css';
import {Footer, Header} from "../../widgets/Header";
import VideoBanner from "../video/VideoBanner";
import 'bootstrap/dist/css/bootstrap.min.css';

function Home() {
    return (
        <div className="hfeed site" id="page">
            <Header />
            <VideoBanner />
            {/* Banner con video de fondo */}
            <div className="home-banner" style={{fontFamily:'Montserrat,sans-serif'}}>
                <div className="home-banner-overlay"></div>
                <div className="home-banner-content">
                    <h1>¿Quienes Somos?</h1>
                    <p>
                        Empresa mexicana dedicada al sector de servicios de recuperación de cartera vencida, cobranza extra judicial, atención al cliente, comprometida con sus colaboradores y en brindar un servicio de calidad apegada a las normas laborales.
                    </p>

                     {/* Sección de Misión y Visión */}
                    <div className="mission-vision container-fluid bg-black text-white py-5">
                        <div className="row">
                            <div className="col-md-6 text-center">
                                <h2 className="mission-title">MISIÓN</h2>
                                <p>Mejorar y fortalecer el desarrollo de nuestros servicios de Contact Center para nuestros clientes, optimizando procesos en soluciones cumpliendo con los estándares de calidad.</p>
                            </div>
                            <div className="col-md-6 text-center">
                                <h2 className="vision-title">VISIÓN</h2>
                                <p>Ser una empresa líder a nivel nacional en el ramo de Contact Center, optimizando los procesos operativos y administrativos en un marco de mejora continua para cumplir con las expectativas de nuestros clientes.</p>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h2 className="mission-title">POLÍTICA DE CALIDAD</h2>
                                <p>En ASGL & ASOC. S.A DE C.V estamos comprometidos en el mejoramiento continuo de nuestros procesos en Atención al Cliente y Cobranza Extrajudicial, con la finalidad de mantener la excelencia para cubrir con los requerimientos de nuestros clientes ofreciendo un servicio de alta calidad, cumpliendo con los requisitos legales, normativos y la integración de criterios de sostenibilidad frente al cambio climático.</p>
                            </div>
                        </div>
                    </div>

                    <div className="mission-vision container-fluid bg-black text-white py-5">
                        <div className="row">
                            <div className="col-md-6 text-center">
                                <a href="/about">
                                    <i class="ri-door-open-fill icon-home"></i>
                                    <h2 className="text-white" style={{fontWeight:'700'}}>NUESTROS SERVICIOS</h2>
                                </a>
                            </div>
                            <div className="col-md-6 text-center">
                                <a href="/contact">
                                    <i class="ri-shake-hands-fill icon-home"></i>
                                    <h2 className="text-white" style={{fontWeight:'700'}}>CONTACTANOS</h2>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Home;